import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { InsideSurveyService } from "src/app/shared/services/inside-survey.service";
import { BuildingLayoutService } from "../../../../services/buildingLayout.service";

@Component({
  selector: "app-unsaved-dialog",
  templateUrl: "./unsaved-dialog.component.html",
  styleUrls: ["./unsaved-dialog.component.scss"],
})
export class UnsavedDialogComponent implements OnInit {
  @Output() yes: EventEmitter<void> = new EventEmitter();
  @Output() no: EventEmitter<void> = new EventEmitter();

  isValid: boolean;

  constructor(
    readonly service: InsideSurveyService,
    readonly activeModal: NgbActiveModal,
    readonly buildingLayoutService: BuildingLayoutService
  ) {}

  ngOnInit(): void {
    this.buildingLayoutService.getLayout().subscribe((res) => {
      this.isValid = res.isValid;
    });
  }

  onYes() {
    this.yes.emit();
    this.activeModal.close();
  }

  onBack() {
    this.activeModal.close();
  }

  onNo() {
    this.no.emit();
    this.activeModal.close();
  }
}
